export default __webpack_public_path__ + "static/media/cancelIcon.5e08791c.svg";